module.exports = __webpack_public_path__ + "static/img/85048H_2_R_20190704_LC.62cffcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85048H_2_R_20190704_LC.png
// module id = eI/H
// module chunks = 0